<template>
    <div style="background: white">
        <policyHeader/>
        <div class="breadBox">
            <a-breadcrumb>
          <span>
            <img src="@/assets/img/position.png"/>
            当前位置：
          </span>
                <a-breadcrumb-item @click="onRollbackHome" style="cursor:pointer">首页</a-breadcrumb-item>
                <a-breadcrumb-item @click="onRollback" style="cursor:pointer">金融课堂</a-breadcrumb-item>
                <a-breadcrumb-item>金融课堂详情</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div class="tabBox">
            <div class="detailTop">
                <VideoPlay
                        v-show="true"
                        :videoUrl="getVideo(detailObj.playPath)"
                        :videoCover="videoCover"
                        :width="800"
                        :height="450"
                        :controls="true"
                        :loop="false"
                        :muted="false"
                        preload="auto"
                        :showPlay="true"
                        :playWidth="96"
                        zoom="cotain"
                        />
                <div class="detailRight">
                    <div class="baseName">{{ detailObj.name }}</div>
                    <div class="time">视频时长:{{ detailObj.frequency }}</div>
                    <div class="baseAddress">点击量:{{ detailObj.hits }}</div>
                    <div class="title">课程介绍</div>
                    <div class="content" v-html="detailObj.introduction"></div>
                </div>
                <div class="collect" @click="onCollect(detailObj.name)" v-if="!collectShow">
                    <StarOutlined/>
                    收藏
                </div>
                <div class="collect" @click="oncancel" v-if="collectShow">
                    <StarOutlined/>
                    已收藏
                </div>
            </div>
            <div class="detailBottom">
                <!-- <div class="introduce">
                    <div class="title">课程介绍</div>
                    <div class="content" v-html="detailObj.introduction"></div>
                </div> -->
                <!-- <div class="other">
                    <div class="title">课程推荐</div>
                    <div v-for="item in baseList.splice(0,2)" :key="item.id" class="imageTitle">
                        <img :src="getImg(item.logo)" alt="" @click="onImgUrl(item.id)">
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import VideoPlay from '@/components/videoPlay'
import {activity, collectWeb, volumeWeb} from "@/api/innovationService";
import { basicsCourseInfoWeb } from "@/api/finance";
import {file_service} from "@/api/adminService";

export default {
    name: "policyDetail",
    components: {VideoPlay},
    data() {
        return {
            detailObj: {},
            baseList: [],
            collectShow: false,
            show:false,
            activityId:""
        }
    },
    created() {
        this.activityId = this.$route.query.id
        this.getDetail(this.activityId)
    },
    mounted() {

        // this.getSignup()
        
        if(this.$ls.get('token')){
            this.getIsCollect()
        this.getvolume()
        }

    },
    methods: {

        onImgUrl(id) {

            this.getDetail(id)
            // this.getSignup()
        },
        getVideo(videoUrl) {
            return file_service.video(videoUrl)
        },
        getDetail(id) {
            this.getAction({
                url: basicsCourseInfoWeb.detail,
                params: {id: id}
            }).then(res => {
                this.detailObj = res
            })
        },
        oncancel(){
            this.postAction({
                url:collectWeb.romver,
                params:{
                    urls:window.location.href,
                    systemType: 'finance'
                }
            }).then(()=>{
                    this.$notification.success({
                                message: '取消收藏',
                                style: {
                                    fontWeight: '600',
                                },
                            });
                this.getIsCollect()
            })
        },
        getIsCollect() {
            this.getAction({
                url:collectWeb.Iscancel,
                params:{
                    urls:window.location.href,
                    systemType: 'finance'
                }
            }).then(res=>{
                this.collectShow = res
            })
        },
        getSignup() {
            this.getAction({
                url: activity.pageList,
                params: {
                    systemType: "finance"
                }
            }).then(res => {
                this.baseList = res.records
            })

        },
        getvolume() {
            this.postAction({
                url: volumeWeb.saveVisits,
                params: {
                    type: 3,
                    name: "finance"
                }
            })
        },
        onCollect(title) {
            if(this.$ls.get('token')){
            let collUrl = window.location.href
            this.postAction({
                url: collectWeb.saveOrUpdate,
                params: {
                    title: title,
                    type: "6",
                    url: collUrl,
                    systemType: 'finance'
                }
            }).then(res => {
                console.log(res, 'res')
                    this.$notification.success({
                                message: '收藏成功',
                                style: {
                                    fontWeight: '600',
                                },
                            });
                this.getIsCollect()
            })
            }else{
                    this.$notification.warning({
                                message: '登录后可以操作',
                                style: {
                                    fontWeight: '600',
                                },
                            });
this.$router.push({ path: '/login', query: { id: 'user' } })
            }
        },
        onRollback() {
            this.$router.push({
                path: "/finance/video",
                query:{
                    type:"金融课堂"
                }
            })
        },
        onRollbackHome() {
            this.$router.push({
                path: "/finance/index",
                query:{
                    type:"首页"
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
.breadBox {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
    background: white;
}

.tabBox {
    width: 1200px;
    margin: 0 auto;
    padding: 10px 0 20px 0;

    .detailTop {
        background: #edf0f7;
        padding: 20px;
        display: flex;
        position: relative;

        img {
            width: 304px;
            height: 171px;
        }

        .detailRight {
            margin-left: 30px;
            padding-top: 20px;
            .title {
                width: 70px;
                margin-top: 20px;
                font-size: 16px;
                border-bottom: 2px solid #2162e4;
                font-weight: 800;
            }

            .content {
                font-size: 16px;
                height: 300px;
                overflow: auto;
                width:100%;
                line-height: 30px;
                margin-top: 20px;
                text-indent: 30px;
            }

            .baseName {
                font-size: 20px;
            }

            .time {
                font-size: 14px;
                color: #666;
                margin-top: 10px;
            }

            .baseAddress {
                font-size: 14px;
                color: #666;
                margin-top: 10px;
            }
            .activerybtn{
                width: 100px;
                height: 40px;
                color: white;
                background: #2162e4;
                border: none;
                margin-top: 20px;
                cursor:pointer
            }
        }

        .collect {
            font-size: 16px;
            position: absolute;
            right: 60px;
            cursor: pointer;
        }
    }

    .detailBottom {
        display: flex;
        margin-top: 20px;
        justify-content: space-between;

        .introduce {
            width: 70%;

            .title {
                width: 70px;
                font-size: 16px;
                border-bottom: 2px solid #2162e4;
                font-weight: 800;
            }

            .content {
                font-size: 16px;
                line-height: 30px;
                margin-top: 20px;
                text-indent: 30px;
            }
        }

        .other {
            width: 27%;

            .title {
                width: 70px;
                font-size: 16px;
                border-bottom: 2px solid #2162e4;
                font-weight: 800;
            }

            .imageTitle {
                margin-top: 20px;

                img {
                    width: 304px;
                    height: 171px;
                }
            }
        }
    }
}
</style>
